import React from "react";
import { Award, Camera, Magnet, Search, Timer } from "lucide-react";

const FEATURES = [
  {
    icon: Timer,
    title: "Live in a minute",
    description: "Chat about your trade. Walk away with a live site.",
  },
  {
    icon: Search,
    title: "Get found",
    description:
      "A page for each service and town you work, so neighbors can find you.",
  },
  {
    icon: Magnet,
    title: "Take quotes",
    description: "They request a quote from your site while you are on a job.",
  },
  {
    icon: Camera,
    title: "Job photos",
    description:
      "Shoot in the Toolkit app or upload from the website. GPS files them.",
  },
  {
    icon: Award,
    title: "Licenses",
    description:
      "Photograph a card. Get a reminder before it expires. Share a link.",
  },
];

export const TrustFeaturesBar: React.FC = () => (
  <section
    id="features"
    className="bg-card border-b border-border relative z-20 shadow-sm -mt-6 sm:-mt-10 mx-4 sm:mx-8 lg:mx-auto max-w-7xl rounded-xl overflow-hidden"
  >
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 divide-y md:divide-y-0 lg:divide-x divide-muted">
      {FEATURES.map(({ icon: Icon, title, description }) => (
        <div
          key={title}
          className="p-8 flex flex-col items-start hover:bg-muted/30 transition-colors"
        >
          <div className="w-12 h-12 bg-premium-50 rounded-xl flex items-center justify-center mb-5 border border-premium-100">
            <Icon className="w-6 h-6 text-premium-600" />
          </div>
          <h3 className="text-lg font-bold text-foreground mb-2">{title}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {description}
          </p>
        </div>
      ))}
    </div>
  </section>
);
